export default () => ({
  iframeSelector: "edm-iframe",
  baseUrl: "https://cdn.education-manager.com",
  getQueryParamFromUrl(param) {
    if (window.location.search) {
      const splittedSearch = window.location.search.split("&");
      const searchParam = splittedSearch.filter((searchParam) => searchParam.includes(`${param}=`));
      const value = searchParam[0].split("=")[1];

      return value;
    }
  },
  getEventListTypeFromUrl() {
    return this.getQueryParamFromUrl("type");
  },
  getEventSlugFromUrl() {
    return this.getQueryParamFromUrl("slug");
  },
  getIframePathForEventList() {
    const type = this.getEventListTypeFromUrl();

    switch (type) {
      case "online":
        return "/events?filter={locations=84}";
      case "workshops":
        return "/events?filter={event_types=3}&simpleList=true&hideFilter=true";
      default:
        return "/events";
    }
  },
  getIframePathForEventDetail() {
    const pathname = window.location.pathname;
    const slug = this.getEventSlugFromUrl();

    return `${pathname}/${slug}`;
  },
  getIframePath() {
    return this.getQueryParamFromUrl("edmPath");
  },
  getIframeUrl(type) {
    switch (type) {
      case "event":
        return `${this.baseUrl}${this.getIframePathForEventDetail()}`;
      case "events":
        return `${this.baseUrl}${this.getIframePathForEventList()}`;
      case "locations":
        return `${this.baseUrl}/locations`;
      case "lecturers":
        return `${this.baseUrl}/lecturers`;
      case "slider":
        return `${this.baseUrl}/events?displayAsSlider=true&navigateOnParent=true&limit=5`;
      default:
        if (this.getIframePath()) {
          return `${this.baseUrl}/${this.getIframePath()}`;
        }
    }
  },
  displayContentOnIndex() {
    if (window.location.pathname === "/" && this.getIframePath()) {
      return false;
    } else {
      return true;
    }
  },
});
